class SuperMenu extends HTMLElement {
  constructor() {
    super();
    this.hamburger = this.querySelector(".hamburger-icon");
    this.hamburger.addEventListener("click", this.toggleMenu.bind(this));
    this.expandableMenus = this.querySelectorAll(".menu-level-2");
    this.assignMenuWidth();
    window.addEventListener("resize", this.assignMenuWidth.bind(this));
    this.superMenus = this.querySelectorAll(".super-menu-link");
    this.levelThreeItems = this.querySelectorAll(".menu-level-3-item");
    this.superMenus.forEach((menu)=> {
      if(menu.querySelector('.menu-level-2')){
        menu.addEventListener("mouseover", ()=>{
          menu.querySelector(".menu-item").classList.add("active");
          menu.querySelector(".menu-level-2").classList.add("open");
        });
        menu.addEventListener("mouseout", ()=>{
          menu.querySelector(".menu-item").classList.remove("active");
          menu.querySelector(".menu-level-2").classList.remove("open");
        })
      }
    });
    this.levelThreeItems.forEach((item)=>{
      if(item.querySelector(".menu-level-4")){
        item.addEventListener("mouseover", ()=>{
          item.querySelector(".menu-level-3-link").classList.add("active");
          item.querySelector(".menu-level-4").classList.add("open");
        });
        item.addEventListener("mouseout", ()=>{
          item.querySelector(".menu-level-3-link").classList.remove("active");
          item.querySelector(".menu-level-4").classList.remove("open");
        })
      }
    })
    this.linksHeight = this.querySelector(".mega-menu-container").offsetHeight;
    this.menuBackground = this.querySelector(".menu-background");
    this.menuBackground.addEventListener("click", this.toggleMenu.bind(this));
    this.levelFours = this.querySelectorAll(".menu-level-4");
    this.levelFours.forEach((menu)=>{
      this.calculateLevelFourPosition(menu);
      menu.addEventListener("mouseover", ()=>{
        this.calculateLevelFourPosition(menu);
      })
    })
    this.expandableMenus.forEach((menu)=>{
      this.calculateMenuPosition(menu);
    })
    window.megaMenuWidth = this.calculateMenuWidth();
    window.megaMenuHeight = this.calculateMaxHeight()
  }
  calculateMaxHeight(){
    const megaMenuSquare = this.querySelector(".mega-menu").getBoundingClientRect();
    return window.innerHeight - megaMenuSquare.top * 2;
  }
  calculateLevelFourPosition(menu){
    if (document.dir == "ltr"){
      const menuRightPosition = menu.getBoundingClientRect().right;
      const windowWidth = window.innerWidth;
      if(menuRightPosition > windowWidth){
        menu.style.left = "auto";
        menu.style.right = 0;
      }
    } else if (document.dir == "rtl"){
      const menuLeftPosition = menu.getBoundingClientRect().left;
      if(menuLeftPosition < 0){
        menu.style.right = "auto";
        menu.style.left = 0;
      }
    }
  }
  calculateMenuWidth() {
    const sectionContainer = document.querySelector(".section-container");
    const sectionContainerOffset = sectionContainer.offsetWidth;
    const sectionContainerStyles = getComputedStyle(sectionContainer);
    const sectionContainerPaddings =
      parseInt(sectionContainerStyles.paddingLeft) +
      parseInt(sectionContainerStyles.paddingRight);
    const staticWidth = this.querySelector(".static-links").offsetWidth;
    const megaMenuWidth = this.querySelector(
      ".mega-menu-container"
    ).offsetWidth;
    return (
      sectionContainerOffset -
      sectionContainerPaddings -
      staticWidth -
      megaMenuWidth
    );
  }
  calculateMenuPosition(menu) {
    const menuHeight = menu.offsetHeight;
    const liItem = (menu.parentElement);
    const liItemBottomPos = liItem.offsetTop + liItem.offsetHeight;
    if(menuHeight > this.linksHeight || menuHeight > liItemBottomPos){
      menu.style.top = 0;
      return;
    }
    else {
      menu.style.top = liItemBottomPos-menuHeight + "px";
      return;
    }    
  }
  toggleMenu() {
    this.classList.toggle("open");
  }
  assignMenuWidth() {
    this.expandableMenus.forEach((menu) => {
      menu.style.maxWidth = this.calculateMenuWidth() + "px";
      if(getComputedStyle(menu).height > this.calculateMaxHeight() + "px"){
        menu.style.width = getComputedStyle(menu).width;
        menu.style.maxHeight = this.calculateMaxHeight() + "px";
        menu.style.overflowY = "scroll";
      }
    });
  }
}
customElements.define("super-menu", SuperMenu);
